/**
 * Dígito verificador de un RUC paraguayo (módulo 11).
 *
 * Está repetido a propósito: el mismo cálculo vive en el backend, que es el que
 * manda. Acá sirve para completar el dígito mientras se carga el cliente, de
 * modo que el error se vea en el formulario y no al guardar. Si alguna vez los
 * dos no coinciden, gana el backend y el formulario muestra su mensaje.
 */
export function calcularDigitoVerificador(numero, base = 11) {
    const limpio = String(numero || '').replace(/\D/g, '');
    if (!limpio) return '';

    let total = 0;
    let multiplicador = 2;
    for (let i = limpio.length - 1; i >= 0; i--) {
        total += Number(limpio[i]) * multiplicador;
        multiplicador = multiplicador >= base ? 2 : multiplicador + 1;
    }
    const resto = total % 11;
    return String(resto <= 1 ? 0 : 11 - resto);
}

/** Cómo se muestra el documento: el número con su dígito, si lo lleva. */
export function documentoCompleto({ tipo_documento, numero_documento, digito_verificador }) {
    if (!numero_documento) return '';
    if (tipo_documento === 'ruc' && digito_verificador) {
        return `${numero_documento}-${digito_verificador}`;
    }
    return numero_documento;
}

export const TIPOS_DOCUMENTO = [
    { valor: 'ruc', etiqueta: 'RUC' },
    { valor: 'ci', etiqueta: 'Cédula de identidad' },
    { valor: 'pasaporte', etiqueta: 'Pasaporte' },
    { valor: 'extranjero', etiqueta: 'Documento extranjero' },
];
